import React from 'react';
const getHighlightedText = (text, search) => {
  // Split text on search term, include term itself into parts, ignore case
  if (!search || typeof text !== 'string') {
    return text;
  }
  let parts = [text];
  try {
    parts = search !== '' ? text.split(new RegExp(`(${search})`, 'gi')) : [text];
  } catch (err) {
    parts = [text];
  }
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === search.toLowerCase() ? (
          <strong key={i} style={{ backgroundColor: '#ffff00aa' }}>
            {part}
          </strong>
        ) : (
          part
        )
      )}
    </>
  );
};
export default getHighlightedText;
